import type { ISendChatStatusData } from '@type/ChatWindow';
import { useCallback } from 'react';
import ioService from '../services/ioService';
import { getUserId } from '../services/localStorageService';

export const useChatStatus = () => {
  const setSendChatStatus = useCallback(
    (statusData: ISendChatStatusData, configId: string) => {
      return ioService.send({
        event: 'userStatus',
        data: {
          data: {
            status: statusData.status,
          },
          id: getUserId(configId),
          type: 'userStatus',
        },
      });
    },
    [],
  );

  return { setSendChatStatus };
};
